// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理x
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

import distributorlist from '@/views/distributor/distributorlist';

import distributorAdd from '@/views/distributor/distributorAdd';

import distributorDetail from '@/views/distributor/distributorDetail';

import distributorSetting from '@/views/distributor/distributorSetting';

import rechargelist from '@/views/recharge/rechargelist';

import rechargeAdd from '@/views/recharge/rechargeAdd';

import rechargeDetail from '@/views/recharge/rechargeDetail';

import accountlist from '@/views/account/accountlist';

import accountrecharge from '@/views/account/accountrecharge';

import accountorders from '@/views/account/accountorders';

import dashboad from '@/views/dashboad';

import orderlist from '@/views/recharge/orderlist';

// 启用路由
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => console.log(err))
}

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/dashboad',
            name: '主页',
            component: dashboad,
            meta: {
                requireAuth: true
            }
        },{
            path: '/goods/Goods',
            name: '商品管理',
            component: distributorlist,
            meta: {
                requireAuth: true
            }
        },{
			path: '/distributor/distributorlist',
			name: '分销商管理',
			component: distributorlist,
			meta: {
			    requireAuth: true
			}
		},{
			path: '/distributor/distributorDetail/:id',
			name: '分销商信息',
			component: distributorDetail,
			meta: {
			    requireAuth: true
			}
		},{
			path: '/distributor/distributorSetting/:id',
			name: '分销商设置',
			component: distributorSetting,
			meta: {
			    requireAuth: true
			}
		},{
			path: '/recharge/rechargelist',
			name: '账户记录',
			component: rechargelist,
			meta: {
			    requireAuth: true
			}
		},{
			path: '/recharge/rechargeAdd',
			name: '账户记录',
			component: rechargeAdd,
			meta: {
			    requireAuth: true
			}
		}, {
			path: '/recharge/rechargeDetail/:id',
			name: '分销商设置',
			component: rechargeDetail,
			meta: {
			    requireAuth: true
			}
		}, {
			path: '/account/accountlist',
			name: '账户管理',
			component: accountlist,
			meta: {
			    requireAuth: true
			}
		},{
            path: '/recharge/orderlist',
			name: '账户充值',
			component: orderlist,
			meta: {
			    requireAuth: true
			}
        }, {
			path: '/account/accountrecharge',
			name: '账户充值',
			component: accountrecharge,
			meta: {
			    requireAuth: true
			}
		},{
			path: '/account/accountorders',
			name: '账户充值',
			component: accountorders,
			meta: {
			    requireAuth: true
			}
		},{
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/distributor/distributorAdd',
            name: '添加分销商',
            component: distributorAdd,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js